import { MapContainer, TileLayer, Marker, Polyline, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useSentinelTheme } from "../contexts/ThemeContext";

const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [22, 36],
  iconAnchor: [11, 36],
});

function ClickCapture({ onClick }) {
  useMapEvents({
    click(e) {
      onClick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

export function RouteEditorMap({ stops = [], onAddStop, center = [41.451, 2.176], height = "320px" }) {
  const { salaControl } = useSentinelTheme();
  const tileUrl = salaControl
    ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
    : "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
  const positions = stops.filter((s) => s.lat && s.lon).map((s) => [s.lat, s.lon]);

  return (
    <div style={{ height }} className="w-full overflow-hidden rounded-lg border border-border relative z-0" data-testid="route-editor-map">
      <MapContainer center={center} zoom={14} style={{ height: "100%", width: "100%" }}>
        <TileLayer url={tileUrl} attribution="&copy; OpenStreetMap &copy; CartoDB" />
        <ClickCapture onClick={onAddStop} />
        {positions.length > 1 && <Polyline positions={positions} pathOptions={{ color: "#7AB800", weight: 2, dashArray: "6 4" }} />}
        {stops.map((s, i) =>
          s.lat && s.lon ? <Marker key={s.id || i} position={[s.lat, s.lon]} icon={markerIcon} /> : null
        )}
      </MapContainer>
    </div>
  );
}
